(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/pages/frejaeid/frejaeid-poll.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/pages/frejaeid/frejaeid-poll.js');

'use strict';

const {
  frejaeIdPollType,
  appWaitStatus
} = svs.playerLogin.constants;
const {
  MainPage,
  HeaderText,
  ModeShiftLink,
  SvsLogo,
  UpdateHeader,
  FooterText,
  SelectEidMenu,
  ScamWarning
} = svs.playerLogin.sharedComponents;
const {
  FrejaeIdStart,
  FrejaeIdWaiting
} = svs.playerLogin.frejaeid.components;

const FrejaeIdPoll = _ref => {
  let {
    isLogin = true,
    pollState = frejaeIdPollType.BEFORE_POLL,
    frejaeIdPollWait = appWaitStatus.WAITING_QRCODE
  } = _ref;
  const {
    ReactIcon: Icon
  } = svs.ui;
  React.useEffect(() => {
    UpdateHeader.updateHeader(isLogin ? 'Logga in' : 'Bli kund');
  }, [isLogin]);
  return React.createElement(MainPage, null, React.createElement(SelectEidMenu, {
    isBankId: false,
    isLogin: isLogin
  }), React.createElement(HeaderText, {
    isLogin: isLogin,
    pollWait: frejaeIdPollWait
  }), React.createElement("div", {
    className: "padding-xs-bottom-2 padding-xs-h-2 login-react-max-width-500"
  }, pollState === frejaeIdPollType.BEFORE_POLL && React.createElement(FrejaeIdStart, {
    isLogin: isLogin
  }), pollState === frejaeIdPollType.WAITING_POLL && React.createElement(FrejaeIdWaiting, {
    frejaeIdPollWait: frejaeIdPollWait,
    isLogin: isLogin
  }), React.createElement(ModeShiftLink, {
    isBankId: false,
    isLogin: isLogin,
    pollState: pollState
  }), React.createElement("span", {
    className: "login-react-hover"
  }, React.createElement("a", {
    href: "https://frejaeid.com/skaffa-freja-eid/"
  }, React.createElement("span", {
    className: "f-inverted f-bold u-text-decoration-underline"
  }, "Skaffa Freja eID"), React.createElement(Icon, {
    className: "margin-left",
    color: "icon-inverted",
    icon: "external_link",
    size: "200"
  }))), React.createElement(ScamWarning, null), React.createElement(SvsLogo, null), React.createElement(FooterText, {
    isBankId: false,
    isLogin: isLogin
  })));
};
svs.playerLogin.frejaeid.FrejaeIdPoll = FrejaeIdPoll;

 })(window);